angular.module('GatorPad.services.Api', ['gatorPadConfig'])

	.service('ApiService', function ($http, $q, $rootScope, baseApiUri, _) {

		// A helper method to prepare an API call
		this.buildCall = function (method, resource, payload) {
			var req = {
				method: method,
				url: baseApiUri + resource
			};

			if (payload) {
				req.data = payload;
			}

			return req;
		};

		// Makes an API call
		this.executeCall = function (req) {
			var deferred = $q.defer();

			$http(req)
				.success(function (data, status, headers, config) {
					deferred.resolve(data);
				})
				.error(function (data, status, headers, config) {
					deferred.resolve(null);
				});

			return deferred.promise;
		};

		this.login = function (username, password) {
			var req = this.buildCall("PUT", "login/", { username: username, password: password });
			return this.executeCall(req);
		};

		this.initializeData = function () {
			var deferred = $q.defer();
			var self = this;

			this.resetLocalStorage(false);
			
			this.getFarmsOnline()
				.then(function (farmList) {
					var tankQs = [];
					angular.forEach(farmList, function (farm) {
						angular.forEach(farm.barns, function (barn) {
							tankQs.push(self.getTanksOnline(barn.id));
						});
					});

					$q.all(tankQs).then(function () {
						deferred.resolve();
					}, function (result) {
						deferred.error("tank");
					});

				}, function (result) {
					deferred.error("farm");
				});

			return deferred.promise;
		}

		// Returns the users farms from local storage.
		this.getFarms = function (cb) {
			var farms = window.localStorage.getItem("farms");
			if (farms) {
				return JSON.parse(farms);
			} else {
				return [];
			}
		};

		// Load the farms from the API
		this.getFarmsOnline = function () {
			console.log("Loading online farms");
			var req = this.buildCall("GET", "farm?disabled=false");

			var deferred = $q.defer();

			$http(req)
				.success(function (data, status, headers, config) {
					var filteredFarms = data;
					if (!$rootScope.sessionData.isAdmin) {
						filteredFarms = _.filter(filteredFarms, function (farm) {
							if (_.indexOf($rootScope.sessionData.farms, farm.id) > -1) {
								return true;
							} else {
								return false;
							}
						});
					}
					filteredFarms = _.sortBy(filteredFarms, "name");
					angular.forEach(filteredFarms, function (farm) {
						var filteredBarns = _.filter(farm.barns, function (barn) {
							return !barn.disabled;
						});
						farm.barns = _.sortBy(filteredBarns, "name");
					});

					window.localStorage.setItem("farms", JSON.stringify(filteredFarms));
					deferred.resolve(filteredFarms);
				})
				.error(function (data, status, headers, config) {
					deferred.resolve(null);
				});

			return deferred.promise;
		};


		// Returns the tanks for the specified barn from local storage.
		this.getTanks = function (barnId, cb) {
			var tankStorageName = "tanks_" + barnId;
			var tanks = window.localStorage.getItem(tankStorageName);
			if (tanks) {
				return JSON.parse(tanks);
			} else {
				return [];
			}
		};

		// Load the tanks from the API.
		this.getTanksOnline = function (barnId) {
			var req = this.buildCall("GET", "pen?barn=" + barnId + "&disabled=false");

			var deferred = $q.defer();

			$http(req)
				.success(function (data, status, headers, config) {
					var sortedList = _.sortBy(data, "name");
					window.localStorage.setItem("tanks_" + barnId, JSON.stringify(sortedList));
					deferred.resolve(data);
				})
				.error(function (data, status, headers, config) {
					deferred.resolve(null);
				});

			return deferred.promise;
		};

		// Clears all session, farm, and tank data from local storage.
		this.resetLocalStorage = function (includeSession) {
			if (includeSession) {
				window.localStorage.removeItem("sessionData");
			}

			for (var i = 0; i < window.localStorage.length; i++) {
				var key = window.localStorage.key(i);

				if (key == "farms" || key.indexOf("tanks_") >= 0) {
					window.localStorage.removeItem(key);
				}
			}
		};

		this.uploadInventory = function (inventoryData) {
			var req = this.buildCall("PUT", "inventoryCount", inventoryData);
			return this.executeCall(req);
		};

		this.uploadFeed = function (feedData) {
			var req = this.buildCall("PUT", "feedCount", feedData);
			return this.executeCall(req);
		};

	});